/*
 * Public API Surface of amaze-player
 */
export * from './lib/amaze-player.module';
export * from './lib/amaze-player.component';
